module.exports = __webpack_public_path__ + "static/media/journey-marketing-analysis.71fe090a.png";